import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=85ebc25a&scoped=true&lang=pug&"
import script from "./MemberList.vue?vue&type=script&lang=ts&"
export * from "./MemberList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ebc25a",
  null
  
)

export default component.exports